/**
 * @file コンポーネント：フル動画ページタイムライントピックコメント スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledComment = styled.div``;

export const StyledCommentBody = styled.dl`
    display: grid;
    grid-template-columns: 28px 1fr;
    grid-template-rows: auto auto;
    grid-column-gap: 12px;

    &::before {
        grid-column: 1 / 2;
        grid-row: 1 / 3;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #7f97f8;
        color: #f9e38d;
        font-size: 12px;
        line-height: 28px;
        text-align: center;
        content: attr(data-initial);
    }

    &.is-other {
        grid-template-columns: 1fr 28px;

        &::before {
            grid-column: 2 / 3;
            grid-row: 1 / 3;
            background-color: #6c757d;
            color: #ffffff;
        }

        > dd {
            grid-column: 1 / 2;

            &::before {
                right: -12px;
                left: unset;
                border-width: 3px 0 3px 12px;
                border-color: transparent transparent transparent #343a40;
            }
        }

        > dt {
            grid-column: 1 / 2;
            text-align: right;
        }
    }
`;

export const StyledCommentBodyText = styled.dd`
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    position: relative;
    padding: 8px;
    background-color: #343a40;
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;

    ${mediaQuery.pc(`
        font-size: 12px;
        line-height: 18px;
    `)};

    ${mediaQuery.pcWide(`
        font-size: 12px;
        line-height: 18px;
    `)};

    &::before {
        position: absolute;
        top: 4px;
        left: -12px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 3px 12px 3px 0;
        border-color: transparent #343a40 transparent transparent;
        content: "";
    }
`;

export const StyledCommentBodyUsername = styled.dt`
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    margin-bottom: 4px;
    color: #ffffff;
    font-size: 11px;

    ${mediaQuery.pc(`
        font-size: 12px;
    `)};

    ${mediaQuery.pcWide(`
        font-size: 12px;
    `)};
`;

export const StyledCommentTime = styled.div`
    margin-bottom: 8px;
    color: #7f97f8;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
`;
